import { createContext } from 'react';

import { State, createState } from '@hookstate/core';

import { IUpdateRawQueryList } from '@models/Update.model';
import { UpdatesLoading } from './Updates.loading';
import { UpdatesError } from './Updates.error';
import { UpdatesCompletedRaw } from './UpdatesCompleted.raw';

export type SortUpdatesCompletedTypes =
  | 'assignee'
  | 'priority'
  | 'subject'
  | 'affects'
  | 'date'
  | 'dueDate'
  | 'count'
  | 'pManufacturers'
  | undefined;

export type DirectionUpdatesCompletedtypes = 'ASC' | 'DESC' | undefined;

interface IUpdatesCompletedContext {
  search: State<string>;
  sort: State<SortUpdatesCompletedTypes>;
  direction: State<DirectionUpdatesCompletedtypes>;
}

export const UpdatesCompletedContext = createContext<IUpdatesCompletedContext>({
  search: createState<string>(''),
  sort: createState<SortUpdatesCompletedTypes>(undefined),
  direction: createState<DirectionUpdatesCompletedtypes>(undefined),
});

interface IUpdatesCompletedQuery {
  data: IUpdateRawQueryList[];
  isLoading: boolean;
  isError: boolean;
  hasMore?: boolean;
  loadMore: () => void;
}

const UpdatesCompletedQuery = ({
  data,
  isLoading,
  isError,
  loadMore,
  hasMore,
}: IUpdatesCompletedQuery) => {
  if (isLoading || !data) {
    return <UpdatesLoading />;
  }

  if (isError) {
    return <UpdatesError />;
  }

  return (
    <UpdatesCompletedRaw
      updateStatuses={data}
      loadMore={loadMore}
      hasMore={hasMore}
    />
  );
};

export { UpdatesCompletedQuery };
